import React from "react";

const InstrumentTypeToggle = ({ selectedType, onTypeChange }) => {
  return (
    <div className="flex bg-p400 rounded-md p-1 border border-n100">
      {["Options", "Futures"].map((type) => (
        <button
          key={type}
          onClick={() => onTypeChange(type)}
          className={`px-2 py-1 text-[10px] font-semibold rounded cursor-pointer flex justify-center items-center gap-1 min-w-16 ${
            selectedType === type ? "bg-n400 text-n900" : "bg-p400 text-n500"
          }`}>
          {type}
        </button>
      ))}
    </div>
  );
};

export default InstrumentTypeToggle;
